import React from 'react';
import SaveExecutionRecord from './SaveExecutionRecord';
import ScreenshotImagePreviewModal from '../../../shared/ScreenshotImagePreviewModal';
import ConfirmSaveExecutionRecord from './ConfirmSaveExecutionRecord';
import { SAVE_OPENED_LINK_TEST_CASE_POPUP } from '../../../../features/automationStudioNew/constants';

export default function AutomationPagePopup({ popup, popupData, onClose, onConfirmSave }) {
    switch (popup) {
        case 'saveExecutionRecord':
            return (
                <SaveExecutionRecord
                    onClose={onClose}
                    popupData={{
                        ...popupData,
                        togglePopup: popupData?.togglePopup ?? onClose,
                    }}
                />
            );
        case 'confirmSaveExecutionRecord':
            return (
                <ConfirmSaveExecutionRecord
                    onClose={onClose}
                    onBack={onClose}
                    failedSteps={popupData?.failedSteps}
                    variant={popupData?.variant}
                    onSave={async () => {
                        if (!onConfirmSave) return;
                        const result = await onConfirmSave();
                        if (result === true) {
                            onClose();
                        } else if (result !== SAVE_OPENED_LINK_TEST_CASE_POPUP) {
                            // Save failed — keep confirm open.
                        }
                    }}
                />
            );
        case 'ImagePreview':
            return (
                <ScreenshotImagePreviewModal
                    open
                    onClose={onClose}
                    imageUrl={popupData?.imageUrl}
                    fileName={popupData?.fileName}
                    rawPath={popupData?.rawPath}
                />
            );
        default:
            return null;
    }
}
